// Dados declarados da empresa. Nunca usar a projeção do simulador ou o
// orçamento do projeto como faturamento realizado.
export const FATURAMENTOS_ANUAIS = [
  ['ate-1mi', 'Até R$ 1 milhão'],
  ['1-5mi', 'R$ 1 a 5 milhões'],
  ['5-20mi', 'R$ 5 a 20 milhões'],
  ['20-100mi', 'R$ 20 a 100 milhões'],
  ['mais-100mi', 'Acima de R$ 100 milhões'],
  ['nao-informado', 'Prefiro não dizer'],
];

export const FAIXAS_FUNCIONARIOS = [
  ['ate-10', 'Até 10'], ['11-30', '11 a 30'], ['31-100', '31 a 100'],
  ['101-300', '101 a 300'], ['mais-300', 'Mais de 300'],
  ['nao-informado', 'Prefiro não dizer'],
];

export const exigeQualificacaoEmpresa = (pathname) =>
  pathname.replace(/\/+$/, '') === '/infoprodutor';

export function qualificacaoEmpresaValida(form) {
  return FATURAMENTOS_ANUAIS.some(([v]) => v === form.annualRevenue)
    && FAIXAS_FUNCIONARIOS.some(([v]) => v === form.employeeCount);
}

export function dadosDaEmpresa(form) {
  if (!qualificacaoEmpresaValida(form)) return null;
  return {
    origem: 'infoprodutor',
    faturamento_anual: form.annualRevenue,
    funcionarios: form.employeeCount,
  };
}
